<template>
  <div>
    <el-row class="main">
      <div class="card-box">
        <!-- 右边卡片 -->
        <div class="card-rb">
          <div class="card-4">
            <el-card>
              <div>
                <el-form :inline="true" class="demo-form-inline" size="mini">
                  <el-form-item label="政策类别:" prop="title">
                    <el-select v-model="value" placeholder="请选择政策类别">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="咨询标题:" prop="title">
                    <el-input v-model="input" placeholder="请输入咨询标题"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="getList()">查询</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="info"  @click="searchReset()">重置</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="three">
                <el-button type="primary" size="mini" @click="addFun()">新增</el-button>
              </div>
              <!-- 表格盒子 -->
              <div class="table_card">
                <el-table
                  ref="singleTable"
                  :data="tableData"
                  highlight-current-row
                  style="width: 100%;margin-top: 16px"
                  border
                >
                  <el-table-column align="center" label="序号" type="index" width="50"></el-table-column>
                  <el-table-column align="center" prop="policyCategories" label="政策类别" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                    <span v-if="scope.row.policyCategories == 0">民政救助</span>
                    <span v-if="scope.row.policyCategories == 1">退役军人服务</span>
                    <span v-if="scope.row.policyCategories == 2">人社保障</span>
                    <span v-if="scope.row.policyCategories == 3">残疾人保障</span>
                    <span v-if="scope.row.policyCategories == 4">卫生健康</span>
                    <span v-if="scope.row.policyCategories == 5">公租房申请</span>
                    <span v-if="scope.row.policyCategories == 6">社区建设</span>
                    <span v-if="scope.row.policyCategories == 7">其它</span>
                  </template> </el-table-column>
                  <el-table-column align="center" prop="title" label="咨询标题" :show-overflow-tooltip="true"></el-table-column>
                  <el-table-column align="center" prop="createDate" label="创建时间" :show-overflow-tooltip="true"></el-table-column>
                  <el-table-column align="center" prop="state" label="状态" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="scope.row.state == 0">启用</span>
                        <span v-if="scope.row.state == 1">禁用</span> 
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" label="操作" align="center" width="150">
                    <template slot-scope="scope">
                      <el-tooltip class="item" effect="dark" content="查看" placement="top-start">
                        <button
                          style="color:skyblue"
                          class="iconfont icon-chakan tabBtn"
                          @click="look(scope.row.id,'look')"
                        ></button>
                      </el-tooltip> 
                      <el-tooltip class="item" effect="dark" content="修改" placement="top-start">
                        <button
                          style="color: #2e99cf;"
                          class="iconfont icon-bianji3 tabBtn"
                          @click="look(scope.row.id,'change')"
                        ></button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                        <button
                          style="color:red"
                          class="iconfont icon-icon7 tabBtn"
                          @click="deletepanduan(scope.row.id,'delete')" key=""
                        ></button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- 分页功能 -->
              <!--background背景色 :page-sizes="[10,20]"页码选择器   layout显示什么内容  total总条数 -->
              <el-pagination :page-size="pageConfig.pageSize"  layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
                  :total="pageConfig.total"></el-pagination>
              </el-card> 
          </div>
        </div>
        <!--    新增/修改弹框-->
        <el-dialog title="新增" :visible.sync="dialogFormVisible">
          <el-form :model="formData">
            <el-form-item label="政策类别" :label-width="formLabelWidth">
              <el-select v-model="formData.policyCategories" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" ></el-option>
              </el-select>
            </el-form-item> 
            <el-form-item label="咨询标题" :label-width="formLabelWidth">
              <el-input v-model="formData.title" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="内容" :label-width="formLabelWidth">
              <el-input v-model="formData.content" autocomplete="off" type="textarea" :row="4"></el-input>
            </el-form-item>
            <el-form-item label="发布平台" :label-width="formLabelWidth">
              <el-checkbox-group v-model="chakeboxList" >
                <el-checkbox label="0">微信公众号</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="状态" :label-width="formLabelWidth">
              <el-radio-group v-model="formData.state">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group> 
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button v-if="sendnum" type="primary" @click="send()">确 定（新增）</el-button>
            <el-button v-if="chengesendnum" type="primary" @click="changeSend()">确 定（修改）</el-button>
          </div>
        </el-dialog>
        <!--    查看弹框-->
        <el-dialog title="查看" :visible.sync="dialogFormVisiblelook">
          <el-form :model="formData">
            <el-form-item label="政策类别" :label-width="formLabelWidth">
              <el-select v-model="formData.policyCategories" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" ></el-option>
              </el-select>
            </el-form-item> 
            <el-form-item label="咨询标题" :label-width="formLabelWidth">
              <el-input disabled v-model="formData.title" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="内容" :label-width="formLabelWidth">
              <el-input disabled v-model="formData.content" autocomplete="off" type="textarea" :row="4"></el-input>
            </el-form-item>
            <el-form-item label="发布平台" :label-width="formLabelWidth">
              <el-checkbox-group v-model="chakeboxList" >
                <el-checkbox disabled label="0">微信公众号</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="状态" :label-width="formLabelWidth">
              <el-radio-group v-model="formData.state">
                <el-radio disabled :label="1">启用</el-radio>
                <el-radio disabled :label="0">禁用</el-radio>
              </el-radio-group> 
            </el-form-item>
          </el-form> 
        </el-dialog>
      </div>
    </el-row>
  </div>
</template>

<script>
import { post } from "@/api/requrestHttp";
export default {
  data() {
    return {
      disabledlaog:true,
      radio: "1",
      valueSwitch: true,
      checked: true,
      dialogFormVisible: false,
      dialogFormVisiblelook: false,
      sendnum :false,
      chengesendnum:false,
      chakeboxList:[],
      options:[
        {label:'民政救助',value:'0'},
        {label:'退役军人服务',value:'1'},
        {label:'人社保障',value:'2'},
        {label:'残疾人保障',value:'3'},
        {label:'卫生健康',value:'4'},
        {label:'公租房申请',value:'5'}, 
        {label:'社区建设',value:'7'},
        {label:'其它',value:'8'}, 
      ], 
      value: "",
      input: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      }, 
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      }, 
      tableData:[],
      formData: { 
        publishPlatform:[]
      },
      formLabelWidth: "130px",
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    //获取列表
    getList: async function () { 
      post("/admin/handle/info/listHandle", {
        ...this.searchList,
        pageSize: this.pageConfig.pageSize,
        pageNo: this.pageConfig.pageNo,
      }).then((res) => { 
        console.log(res);
        this.tableData = res.content.list;
        this.pageConfig.total = res.content.count
      });
    },
    //分页
			handleCurrentChange(val) {
				this.pageConfig.pageNo = val;
				this.getList();
			},
    look(id, type) { 
      if(type == 'change'){
        this.sendnum = false;
        this.chengesendnum = true;
        this.disabledlaog = false;
        this.dialogFormVisible = true;
      } 
      if(type == 'look'){
        this.dialogFormVisiblelook = true ;
        this.sendnum = false;
        this.chengesendnum = false;
      }
      post("/admin/handle/info/getHandle", {
        id: id,
      }).then((res) => {
        if (res.code == 200) {
            this.$message({ message: "获取信息详情成功", type: "success" });
            console.log(res);
            this.formData = res.content;
            this.checkList = res.content.publishPlatform.split(","); 
            this.formData.state = Number( this.formData.state );
            console.log(this.formData.state); 
            
          }else{
            this.$message({ message: "获取信息详情失败，请检查网络", type: "error" });
          }
      });
    },
    
    cancel(){
      console.log(1111);
      this.dialogFormVisible = false 
    },
    //删除方法
    deletepanduan: async function (id) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => { 
        post("/admin/handle/info/deleteHandle", {
          id: id,
        }).then((res) => {
          if (res.code == 200) {
            this.$message({ message: "删除成功", type: "success" });
            this.getList();
          }else{
            this.$message({ message: "删除失败", type: "error" });
          }
        });
      });
    }, 
    addFun(){ 
      console.log('addFun');   
      this.sendnum = true;
      this.chengesendnum = false;
      this.dialogFormVisible = true; 
      this.formData = { }
      this.chakeboxList = [] 
    },
    searchReset() {
      this.formData = {};
      this.fileListImg = [];
    }, 
    changeSend(){ 
        let publishPlat = this.chakeboxList.toString()
        let params = {
          ...this.formData,
          publishPlatform:publishPlat, 
        } 
        console.log(params);
        post("/admin/handle/info/updateHandle", params).then((res) => {
          if (res.code == 200) {
            this.$message({ message: "修改成功", type: "success" });
            this.dialogFormVisible = false;
            this.getList();
          }else{
            this.$message({ message: "新增失败", type: "error" });
          }
        });
    },
    send() { 
      console.log('新增');   
      let publishPlat = this.chakeboxList.toString()
      let params = {
          publishPlatform:publishPlat,
          policyCategories:this.formData.policyCategories,
          title:this.formData.title,
          content:this.formData.content,
          state:this.formData.state,
      }  
      post("/admin/handle/info/insertHandle", params).then((res) => {
        if (res.code == 200) {
          this.$message({ message: "新增成功", type: "success" });
          this.dialogFormVisible = false;
          this.getList();
        }else{
          this.$message({ message: "新增失败", type: "error" });
        }
      });
    },
  }, 
  changedata(id, type){
    
      let publishPlat = this.formData.publishPlatform.toString()
      console.log(publishPlat); 
      let params = Object.assign(this.formData,{
          publishPlatform: publishPlat
      }) 
      console.log(params);
      post("/admin/policyInformation/info/insertPolicyInformation", params).then((res) => {
        console.log(res); 
        if (res.code == 200) {
          this.$message({ message: "新增成功", type: "success" });
          this.dialogFormVisible = false;
          this.getList();
        }else{
          this.$message({ message: "新增失败", type: "error" });
        }
      });
    }, 
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  height: 100%;
  position: relative;
  .mapdiv {
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
  .pic {
    height: 50px;
    width: 100%;
    position: absolute;
    bottom: 50px;
    left: 0;
    z-index: 9999;
    background-image: url("../../../assets/images/zhzx.png");
    background-size: 100% 100%;
    .pic-nav {
      width: 50%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
    }
    .nav-cli {
      cursor: pointer;
      width: 30%;
      height: 80%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      font-size: 18px;
    }
  }
  .m-lr1 {
    display: flex;
    align-items: center;
    z-index: 999;
    position: absolute;
    top: 0;
    left: 0;
    height: calc(100% - 88px);
    width: 20vw;
    background-color: rgba(252, 250, 250, 0.1);
    .m-cli {
      width: 100%;
      height: 50%;
    }
  }
  .m-lr2 {
    z-index: 999;
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
    top: 0;
    height: calc(100% - 88px);
    width: 20vw;
    background-color: rgba(252, 250, 250, 0.1);
    .m-cli {
      width: 100%;
      height: 50%;
    }
  }
}

// 左上echart盒子
#l-t-chartbox,
#l-b-chartbox,
#r-t-chartbox,
#r-b-chartbox {
  // margin-top: 10%;
  // padding-top: 8%;
  width: 100%;
  height: 100%;
  // background-color: rgb(172, 149, 149);
}
.chart_title {
  width: 100%;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}
// 重置按钮和全屏按钮
.mapbox {
  position: relative;
  height: 100%;
  width: 100%;
  .quanping {
    color: #fff;
    font-size: 30px;
    position: absolute;
    right: 20px;
    top: 40px;
    font-weight: 600;
    z-index: 4;
  }
  .chongzhi {
    color: #fff;
    font-size: 32px;
    position: absolute;
    right: 20px;
    top: 90px;
    font-weight: 500;
    z-index: 4;
  }
  .quxiao {
    color: #fff;
    font-size: 30px;
    position: absolute;
    right: 20px;
    top: 140px;
    font-weight: 400;
    z-index: 4;
  }
}
.mapboxactive {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
.zoomInIcon {
  width: 31px;
  height: 31px;
}
</style>
<style lang='less' scoped>
/deep/.tabBtn {
  font-size: 18px;
}
</style>
